<app-ambiente-banner />
<router-outlet />

@if (loadingService.isLoading()) {
  <div class="loading-overlay d-flex flex-column justify-content-center align-items-center">
    <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Carregando...</span>
    </div>
    <h5 class="text-white mt-3 fw-light">Processando requisição...</h5>
  </div>
}